// extracted by mini-css-extract-plugin
export var dividerContainer = "_87-0";
export var line = "_87-1";